import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEnGb from '@angular/common/locales/en-GB';
import localeSv from '@angular/common/locales/sv';
import localeFrCh from '@angular/common/locales/fr-CH';
import localeDeCh from '@angular/common/locales/de-CH';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIconsModule } from '@ng-icons/core';
import { phosphorInfo } from '@ng-icons/phosphor-icons/regular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { NavbarComponent } from './components/navbar/navbar.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { StatusComponent } from './components/dashboard/status/status.component';
import { HistoryComponent } from './components/dashboard/history/history.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { DetailsComponent } from './components/dashboard/details/details.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { DesignComponent } from './components/design/design.component';
import { HistoryitemComponent } from './components/dashboard/historyitem/historyitem.component';
import { RisklevelComponent } from './components/dashboard/risklevel/risklevel.component';
import { StandardButtonDirective } from './shared/directives/standard-button.directive';
import { SecondaryButtonDirective } from './shared/directives/secondary-button.directive';
import { LinkButtonDirective } from './shared/directives/link-button.directive';
import { ParagraphDirective } from './shared/directives/paragraph.directive';
import { RecommendationTileComponent } from './components/dashboard/recommendation-tile/recommendation-tile.component';
import { WhiteButtonDirective } from './shared/directives/white-button.directive';
import { MoreTipsComponent } from './components/dashboard/more-tips/more-tips.component';
import { TipsTileComponent } from './components/dashboard/tips-tile/tips-tile.component';
import { TopTabsComponent } from './components/top-tabs/top-tabs.component';
import { ErrorComponent } from './components/error/error.component';
import { RedoTestComponent } from './components/dashboard/redo-test/redo-test.component';
import { SmartLinkComponent } from './components/smart-link/smart-link.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { Client, API_BASE_URL } from './generated-api-proxy';
import { Brand } from 'src/brands/brand';
import { environment } from '../environments/environment';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { NotLoggedInComponent } from './components/not-logged-in/not-logged-in.component';
import { CmsTextPipe } from './pipes/cms-text.pipe';
import { RelativeDateCmsTextPipe } from './pipes/relative-date-cms-text.pipe';
import { LocaleService } from './services/locale.service';

// Date/number formatting data for every culture in any brand's supportedLocales ("sv-SE" falls back to "sv").
[localeEnGb, localeSv, localeFrCh, localeDeCh].forEach(data => registerLocaleData(data));

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    DashboardComponent,
    StatusComponent,
    HistoryComponent,
    WelcomeComponent,
    DetailsComponent,
    PageNotFoundComponent,
    ErrorComponent,
    DesignComponent,
    HistoryitemComponent,
    RisklevelComponent,
    RecommendationTileComponent,
    SecondaryButtonDirective,
    WhiteButtonDirective,
    MoreTipsComponent,
    TipsTileComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TopTabsComponent,
    RedoTestComponent,
    ParagraphDirective,
    StandardButtonDirective,
    LinkButtonDirective,
    SmartLinkComponent,
    NotLoggedInComponent,
    CmsTextPipe,
    RelativeDateCmsTextPipe,
    NgIconsModule.withIcons({ phosphorInfo })
  ],
  providers: [
    Client,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: API_BASE_URL, useValue: environment.mockBackend ? Brand.mockBackendUrl : Brand.prodBackendUrl },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: LOCALE_ID, useFactory: (locale: LocaleService) => locale.current, deps: [LocaleService] },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
